var _path;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgGraphUpwards = function SvgGraphUpwards(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89,
    height: 68,
    viewBox: "0 0 89 68",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Retailberater") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, desc === undefined ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, "Created with Sketch.") : desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "#183E62",
    strokeWidth: 2,
    d: "M85.281 56H11.875V3.75c0-1.52-1.217-2.75-2.719-2.75H3.72C2.217 1 1 2.23 1 3.75V61.5C1 64.537 3.435 67 6.438 67H85.28C86.783 67 88 65.77 88 64.25v-5.5c0-1.52-1.217-2.75-2.719-2.75ZM79.293 7H59.31c-3.62 0-5.433 4.385-2.873 6.95l5.484 5.497L49.5 31.896 37.08 19.449a5.407 5.407 0 0 0-7.659 0L17.793 31.102a2.72 2.72 0 0 0 0 3.839l3.83 3.837a2.704 2.704 0 0 0 3.83 0l7.797-7.815L45.67 43.41a5.407 5.407 0 0 0 7.66 0l16.25-16.287 5.485 5.497c2.56 2.565 6.935.748 6.935-2.879V9.714A2.71 2.71 0 0 0 79.293 7Z"
  })));
};
export default SvgGraphUpwards;